export function formatDate(isoString, timeZone = "Europe/Brussels") {
  if (!isoString) {
    return "";
  }

  const date = new Date(isoString);
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone,
  };

  return new Intl.DateTimeFormat("en-GB", options)
    .format(date)
    .replace(",", "") // Remove any comma if present
    .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$1-$2-$3");
}

export function formatDateParts(isoString, timeZone = "Europe/Brussels") {
  const formatted = formatDate(isoString, timeZone);
  if (!formatted) return { date: "", time: "" };
  const parts = formatted.split(" ");
  return { date: parts[0] || "", time: parts.slice(1).join(" ") || "" };
}

export function formatDateOnly(isoString, timeZone = "Europe/Brussels") {
  if (!isoString) {
    return "";
  }
  const date = new Date(isoString);
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone,
  };

  return new Intl.DateTimeFormat("en-GB", options)
    .format(date)
    .replace(",", "") // Remove any comma if present
    .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$1-$2-$3");
}
